import { Fragment, type ReactNode } from "react";

import { Separator } from "@/components/ui/separator";

import { StepBlock } from "./StepBlock";

export interface HelpStep {
  id?: string | number;
  text: string | ReactNode;
  image: string;
}

interface StepsListProps {
  partLabel: string;
  steps: HelpStep[];
}

export const StepsList = ({ partLabel, steps }: StepsListProps) => {
  const total = steps.length;

  return (
    <div className="rounded-mds flex w-full flex-col gap-12 overflow-hidden bg-neutral-200/2 p-6">
      {steps.map((item, index) => {
        const stepLabel = `${index + 1}/${total} шаг`;

        return (
          <Fragment key={item.id ?? index}>
            <StepBlock
              part={partLabel}
              stepLabel={stepLabel}
              text={item.text}
              image={item.image}
            />

            {index < total - 1 && <Separator className="bg-neutral-200/12" />}
          </Fragment>
        );
      })}
    </div>
  );
};
